import React from 'react';
import {useHistory} from 'react-router';
import {Avatar, Box, Container, Card, CardContent, Divider, Typography, makeStyles, Button} from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import Page from 'src/components/Page';
import {LoginForm} from 'src/sections/login/LoginForm';
import {UI_FORGOT_PASSWORD} from 'src/defs/paths';
import {locales} from '../locales';

const useStyles = makeStyles((theme) => ({
    root: {
        justifyContent: 'center',
        display: 'flex',
        height: '100%',
        minHeight: '100%',
        flexDirection: 'column',
        paddingBottom: 80,
        paddingTop: 80,
    },
    backButton: {
        marginLeft: theme.spacing(2),
    },
    card: {
        overflow: 'visible',
        display: 'flex',
        position: 'relative',
        '& > *': {
            flexGrow: 1,
            flexBasis: '50%',
            width: '50%',
        },
    },
    content: {
        padding: theme.spacing(8, 4, 3, 4),
    },
    icon: {
        color: theme.palette.common.white,
        borderRadius: theme.shape.borderRadius,
        padding: theme.spacing(1),
        position: 'absolute',
        top: -32,
        left: theme.spacing(3),
        height: 64,
        width: 64,
    },
}));

const Login = () => {
    const classes = useStyles();
    const history = useHistory();

    const handleSubmitSuccess = () => {
        history.push('/app');
    };

    return (
        <Page className={classes.root} title='Login'>
            <Container maxWidth='sm'>
                <Card className={classes.card}>
                    <CardContent className={classes.content}>
                        <Avatar className={classes.icon}>
                            <LockIcon fontSize='large' />
                        </Avatar>
                        <Typography variant='h2' color='textPrimary'>
                            {locales.signIn}
                        </Typography>
                        <Typography variant='subtitle1' color='textSecondary'>
                            {locales.signInInternal}
                        </Typography>
                        <Box mt={3}>
                            <LoginForm onSubmitSuccess={handleSubmitSuccess} />
                        </Box>
                        <Box mt={3}>
                            <Button color='primary' size='large' variant='text' href={UI_FORGOT_PASSWORD}>
                                {locales.forgotPassword}
                            </Button>
                        </Box>
                        <Box my={2}>
                            <Divider />
                        </Box>
                    </CardContent>
                </Card>
            </Container>
        </Page>
    );
};

export default Login;
